<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" id="prologue">
<div class="heading heading-with-title heading-without-image" id="prologue-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Prologue</h1>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<div class="blockquote-container prose without-attribution">
<blockquote class="prose without-attribution">
<div class="blockquote-image-block blockquote-image-aspect-wide">
<div class="blockquote-image-size-container">
<img alt="" class="blockquote-image-image" src="images/blockquote-big-66-screen.png"/>
</div>
</div>
<p class="first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last">We are born in debt, owing the world a death.”    <i>~David J. Morris</i></p>
</blockquote>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width"><span class="first-phrase"><span class="smallcaps">My name is</span> Angela Rossi,</span> and this is the story of how I die...</p>
<p class="subsq">I once was a doctor, a wife, a daughter, a sister, a lover... Now I’m a fugitive, hiding from an enemy targeting everyone I hold dear.</p>
<p class="subsq">This is a story of good and evil, of temptation and betrayal, of love and obsession.</p>
<p class="subsq">I’m dying and alone, exiled from the people I love most, and this is the story of how I save the world.</p>
<p class="subsq">At least I hope so.</p>
<p class="subsq">Because, if I fail, you may be next...</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?006b4f0e